import { isSameDay } from "date-fns";

import { CalendarDay } from "~/shared.types";
import {
  formatDateForAPI,
  generateCalendarDaysForMonth,
  getFirstBusinessDayOfMonth,
} from "~/utils";

type MonthChangeParams = {
  monthYear: { month: string; year: number };
  hasAppointments: (date: Date) => boolean;
  setCurrentMonthYear: (monthYear: { month: string; year: number }) => void;
  setCurrentStartDate: (date: string) => void;
  setCalendarDays: (days: CalendarDay[]) => void;
  setSelectedDay: (day: CalendarDay) => void;
  updateUrl?: boolean;
};

export const handleMonthChange = async ({
  monthYear,
  hasAppointments,
  setCurrentMonthYear,
  setCurrentStartDate,
  setCalendarDays,
  setSelectedDay,
  updateUrl = true,
}: MonthChangeParams) => {
  setCurrentMonthYear(monthYear);

  const monthIndex = new Date(
    `${monthYear.month} 1, ${monthYear.year}`,
  ).getMonth();
  const today = new Date();
  const isCurrentMonth =
    monthYear.year === today.getFullYear() && monthIndex === today.getMonth();

  const newStartDate = isCurrentMonth
    ? formatDateForAPI(today)
    : formatDateForAPI(getFirstBusinessDayOfMonth(monthYear.year, monthIndex));

  setCurrentStartDate(newStartDate);

  if (updateUrl) {
    const url = new URL(window.location.href);
    url.searchParams.set("startDate", newStartDate);
    url.searchParams.set("month", `${monthYear.month}-${monthYear.year}`);
    window.history.replaceState({}, "", url.toString());
  }

  const newCalendarDays = generateCalendarDaysForMonth(
    monthYear.year,
    monthIndex,
  );
  setCalendarDays(newCalendarDays);

  const preferredDate = today;

  const dayToSelect =
    newCalendarDays.find(
      (day) =>
        isSameDay(day.date, preferredDate) &&
        day.isAvailable &&
        hasAppointments(day.date),
    ) ||
    newCalendarDays.find(
      (day) => day.isAvailable && hasAppointments(day.date),
    ) ||
    newCalendarDays.find((day) => day.isAvailable);

  if (dayToSelect) setSelectedDay(dayToSelect);
};
